import React from 'react';
import { BaseOverrideNoHidden } from 'Views/Page/Content/Templates/BaseOverride';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import WhatIfWizardCollectionStepperTemplate from 'Views/Page/Content/Templates/WhatIfWizardCollectionStepperTemplate';
import Layout from './Layout';

const styles = () => ({
  root: {},
});

const VirtualAccountsSetupStepper = ({ classes, resource }) => {
  return (
    <WhatIfWizardCollectionStepperTemplate
      className={classes.root}
      layout={Layout}
      collection={resource?.attr('virtualAccountsToUpdate')}
      metaOverrideSet={BaseOverrideNoHidden}
    />
  );
};

VirtualAccountsSetupStepper.propTypes = {
  classes: PropTypes.object.isRequired,
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};

export default withStyles(styles)(VirtualAccountsSetupStepper);
